import React, { useMemo } from 'react';
import {
  MEMBERSHIP_DURATION_OPTIONS,
  formatDurationShortLabel,
} from '@/utils/membershipDuration';
import '@/styles/duration-picker.css';

export default function DurationPicker({
  value,
  onChange,
  options = MEMBERSHIP_DURATION_OPTIONS,
  allowUnlimited = false,
  unlimitedLabel = '不限时长',
  label,
  labelClassName = '',
  hint,
  hintClassName = 'duration-picker__hint',
  className = '',
  id,
}) {
  const sortedOptions = useMemo(
    () => [...options].sort((a, b) => a.months - b.months),
    [options],
  );
  const numericValue = value === '' || value == null ? null : Number(value);
  const isUnlimited = allowUnlimited && (value === '' || value == null);

  const selectValue = (months) => {
    onChange(months);
  };

  return (
    <div className={`duration-picker ${className}`.trim()}>
      {label ? (
        <span className={`duration-picker__label ${labelClassName}`.trim()} id={id}>
          {label}
        </span>
      ) : null}
      <div className="duration-picker__body">
        <div className="duration-picker__controls" role="group" aria-labelledby={id}>
          {allowUnlimited ? (
            <button
              type="button"
              className={`duration-picker__btn${isUnlimited ? ' duration-picker__btn--active' : ''}`}
              onClick={() => selectValue('')}
              aria-pressed={isUnlimited}
            >
              {unlimitedLabel}
            </button>
          ) : null}
          {sortedOptions.map((opt) => {
            const active = numericValue === opt.months;
            return (
              <button
                key={opt.code || opt.months}
                type="button"
                className={`duration-picker__btn${active ? ' duration-picker__btn--active' : ''}`}
                onClick={() => selectValue(opt.months)}
                aria-pressed={active}
              >
                {formatDurationShortLabel(opt.months)}
              </button>
            );
          })}
        </div>
        {hint ? <small className={hintClassName}>{hint}</small> : null}
      </div>
    </div>
  );
}
